<template>
  <div id="Index" class="pt-3 py-sm-0" @click="offClickSearchBar()">

    <div class="wrapper">
      <!-- 🌐 Language Switcher -->
      <span class="position-absolute d-flex align-items-center" id="switchLang">
        <span class="cursor_pointer me-1" @click="setLang('en')"
          :class="{ 'opacity-50': $i18n.locale !== 'en' }">🇬🇧</span>
        <span class="cursor_pointer" @click="setLang('th')" :class="{ 'opacity-50': $i18n.locale !== 'th' }">🇹🇭</span>
      </span>
      <div class="content">
        <section>
          <div class="main">
            <div class="container">
              <div class="row ">
                <div class="col-12 text-center ">
                  <div class="searchContainer">
                    <!-- <h2 class="search-in-thailand mb-0">Search in Thailand</h2> -->
                    <!-- <img class="mb-2" src="@/assets/sit-logo-trans-final.png" width="295" /> -->
                    <!-- <img class="mb-2" src="@/assets/sit-logo-ele.png" width="300" /> -->
                    <img src="@/assets/SIT-White-Logo.png" width="400" style="height: 80px; object-fit: cover;" />
                    <p class="text-white fs-5 mb-1">{{ $t('index.tagline') }}</p>
                    <!-- col-xl-4 col-md-6 col-sm-9 col-11 -->
                    <div class="col-12 mx-auto position-relative" @click="offSearchBar = true;">
                      <!-- <form class="inner-addon right-addon mb-2" @submit.prevent="search">
                        <i class="icon fas fa-search text-danger"></i>
                        <input type="text" ref="inputSearch" id="inputSearch" v-model="inputSearch"
                          class="form-control form-control-lg bg-white text-center"
                          :placeholder="$t('index.placeholder')" autocomplete="off" @click="displayList = true"
                          @focus="displayList = true"
                          @input="fullResult = false; (resultSearch.length) ? displayList = false : null">
                      </form> -->
                      <!-- <button type="button" class="btn btn-sm btn-outline-dark btn-rounded py-2 px-4 me-2"
                        @click="redirect('/news')">News</button> -->
                      <!-- <button type="button" class="btn btn-sm btn-outline-dark btn-rounded py-2 px-4 me-2"
                        @click="redirect('/videos')">Videos</button> -->
                      <div class="position-relative d-inline-block">
                        <button type="button" class="btn btn-emp-board btn-rounded py-2 px-4 pe-4"
                          @click="redirect('/jobseeker')">
                          <span class="ms-2">{{ $t('index.employmentNetwork') }}</span>
                          <span class="ms-3"><img src="@/assets/employer-1.svg" width="28" /></span>
                        </button>
                        <span class="beta-badge position-absolute">
                          Beta v1.0
                          <span class="tooltip">{{ $t('index.betaTooltip') }}</span>
                        </span>
                      </div>
                      <p class="fw-bold text-white mt-1">
                        <i>{{ $t('index.joinCommunity') }}</i>
                      </p>

                      <ul class="searchResult scroll-dark text-start" v-if="resultSearch.length && displayList">
                        <li class="card text-truncate mb-1" v-for="result in resultSearch" :key="result.id">
                          <div class="card-body px-2 py-1">
                            <div class="row align-items-center cursor_pointer" @click="clickToList(result)">
                              <div class="col-xl-3 col-4">
                                <img v-lazy="r_image(result)" :alt="result.company_name" class="p-0"
                                  style="object-fit: cover; height: 100%;">
                              </div>
                              <div class="col-xl-9 col-8 px-0">
                                <h6 class="mb-0" style="color:#004393">{{ r_title(result) }}</h6>
                                <p class="mb-0" v-if="result.category == 'company'">
                                  <small class="me-1">
                                    {{ r_type(result.company_type) }}</small>
                                </p>
                                <p class="mb-0" v-else-if="result.category == 'pages'">
                                  <small>{{ $t('index.article') }}</small>
                                </p>
                                <div class="mb-0 text-description_v" v-html="r_description(result)"></div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </div>

    </div>

  </div>
</template>

<script>
// import Repository, { baseUrl, baseApi, secret } from '../../repository.js';
import { baseUrl } from '../../repository.js';


export default {
  name: 'IndexPage',
  metaInfo() {
    return {
      title: "SearchinThailand",
    }
  },
  props: {
    menus: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      baseURL: baseUrl,
      showOptions: false,
      showProvinces: false,
      showCities: false,

      inputSearch: "",
      currentPage: 1,
      limitData: 25,
      displayList: false,

      resultSearch: [],
      loadingMore: false,
      offSearchBar: false,
    }
  },
  // mounted() {
  //   this.$refs.inputSearch.focus();
  // },
  methods: {
    setLang(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('language', lang) // optional: save selected language
    },
    async search() {
      if (!this.inputSearch.trim()) {
        this.inputSearch = "";
        return;
      } else {
        this.redirect("/search", { s: this.inputSearch.trim() })
      }

      // if (this.currentPage == 1) {
      //   this.resultSearch = [];
      // } else {
      //   this.loadingMore = true;
      // }
      // var url = baseApi + "Search/special_company_limit/" + secret;
      // var data = new FormData();
      // if (this.inputSearch.trim()) data.set("name", this.inputSearch.trim());
      // data.set("limit", this.limitData);
      // data.set("page", this.currentPage);
      // data.set("secret", secret);
      // await Repository.post(url, data)
      //   .then(response => {
      //     console.log(response.data);
      //     if (response.data.error == 0) {
      //       this.resultSearch = [...response.data.data];
      //       // response.data.data.forEach((e) => {
      //       //   this.resultSearch.push(e);
      //       // });

      //       if (response.data.data.length < this.limitData) this.fullResult = true;
      //     }
      //   })
      //   .catch(error => ({ error: JSON.stringify(error) }))
      //   .then(() => this.displayList = true);
    },
    r_title(val) {
      return val.company_name;
    },
    r_image(val) {
      return this.baseURL + val.img;
    },
    r_description(val) {
      if (val.company_type < 3) {
        return val.description_v;
      } else if (val.company_type == 3) {
        return val.note_v;
      }
    },
    offClickSearchBar() {
      if (this.displayList) {
        setTimeout(() => {
          if (!this.offSearchBar) {
            this.displayList = false;
          }
        }, 1);
      }
    },
    clickToList(val) {
      this.redirect(`/company/${val.c_code}`, { company: JSON.stringify(val) });
    }
  },
  watch: {
    offSearchBar(val) {
      if (val) setTimeout(() => this.offSearchBar = false, 100);
    },
  }
}
</script>

<style scoped>
@font-face {
  font-family: 'FenwayPark';
  src: url('@/assets/ufonts.com_fenway-park-jf.ttf') format('truetype');
}

.search-in-thailand {
  font-family: 'FenwayPark', sans-serif !important;
  color: #333;
  font-size: 40px;
}

#Index {
  /* height: 100%; */
  min-height: 94vh;
  background-color: #0635a1;
  background-image: url('@/assets/ThailandMap.png');
  background-position: center 10px;
  background-size: 480px;
  background-repeat: no-repeat;
}

#Index .wrapper {
  display: flex;
  flex-direction: column;
  min-height: 94vh;
}

#Index .content {
  flex: 1 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

#Index .main {
  min-height: 200px;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

@media (min-width: 575px) {
  #Index .search-in-thailand {
    font-size: 55px;
  }

  #Index .main {
    min-width: 450px;
  }
}

@media (max-width: 575px) {
  #Index .wrapper {
    min-height: 80vh;
  }
}

/* ---------------------------------------------------------- */
#inputSearch {
  font-size: 14px;
  border: none;
  color: #7486af;
}

#inputSearch::placeholder {
  color: #7486af;
}

#Index .searchResult {
  width: 100%;
  height: 400px;
  overflow-y: auto;
  position: absolute;
  z-index: 2;
}

/* enable absolute positioning */
.inner-addon {
  position: relative;
}

/* style icon */
.inner-addon .icon {
  position: absolute;
  padding: 10px;
  pointer-events: none;
}

/* align icon */
.left-addon .icon {
  left: 0px;
}

.right-addon .icon {
  right: 0px;
}

/* add padding  */
.left-addon input {
  padding-left: 30px;
}

.right-addon input {
  padding-right: 30px;
}

/* CSS */
.btn-emp-board {
  align-items: center;
  appearance: none;
  background-color: #FCFCFD;
  border-radius: 50px;
  border-width: 0;
  box-shadow: rgba(45, 35, 66, 0.4) 0 2px 4px, rgba(45, 35, 66, 0.3) 0 7px 13px -3px, #adadfb 0px -3px 10px 5px inset;
  box-sizing: border-box;
  color: #3273dc;
  cursor: pointer;
  display: inline-flex;
  height: 48px;
  justify-content: center;
  line-height: 1;
  list-style: none;
  overflow: hidden;
  padding-left: 16px;
  padding-right: 16px;
  position: relative;
  text-align: left;
  text-decoration: none;
  transition: box-shadow .15s, transform .15s;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  white-space: nowrap;
  will-change: box-shadow, transform;
  font-size: 18px;
}

.btn-emp-board:focus {
  box-shadow: #D6D6E7 0 0 0 1.5px inset, rgba(45, 35, 66, 0.4) 0 2px 4px, rgba(45, 35, 66, 0.3) 0 7px 13px -3px, #D6D6E7 0 -3px 0 inset;
}

.btn-emp-board:hover {
  transform: translateY(-1px);
}

.btn-emp-board:active {
  box-shadow: #D6D6E7 0 3px 7px inset;
  transform: translateY(1px);
}

.beta-badge {
  top: -10px;
  left: -35px;
  /* moved 50% more left */
  background-color: #ff5c5c;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 8px;
  border: 1px solid #ff9999;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  white-space: nowrap;
  z-index: 10;
  animation: pulseBadge 2s infinite;
  transition: all 0.3s ease-in-out;
  cursor: default;
  position: absolute;
}

/* Tooltip inside badge */
.beta-badge .tooltip {
  visibility: hidden;
  opacity: 0;
  width: max-content;
  background-color: #444;
  color: #fff;
  text-align: center;
  border-radius: 4px;
  padding: 6px 8px;
  font-size: 11px;
  position: absolute;
  z-index: 20;
  bottom: 25px;
  left: 190%;
  transform: translateX(-50%);
  transition: opacity 0.3s ease;
  pointer-events: none;
  white-space: nowrap;
}

.beta-badge:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

/* Pulse animation */
@keyframes pulseBadge {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 92, 92, 0.6);
  }

  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(255, 92, 92, 0);
  }

  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 92, 92, 0);
  }
}
</style>

<style scoped>
#switchLang {
  top: 1px;
  right: 30px;
  font-size: 30px;
}

@media (max-width: 576px) {
  #switchLang {
    top: 1px;
    right: 5px;
    font-size: 24px;
  }
}
</style>